export default __webpack_public_path__ + "static/media/birta_wall.4c273021.png";